import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { actions } from "redux/reducers";
import api from "api";
import "./login.scss";

function Login() {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);

    const doLogin2 = async () => {
        setLoading(true);
        try {
            const data = await api.user.login(email, password);
            localStorage.AccessToken = data.access_token;
            await getUser();
            await getClients();
            if (location.pathname.includes("login")) {
                setLoading(false);
                history.push("/clients");
            } else {
                setLoading(false);
                history.push(location.pathname);
            }
        } catch (err: any) {
            toast.error(err.toString());
            setLoading(false);
        }
    };

    const getUser = async () => {
        const data = await api.user.get();
        dispatch(actions.user.set(data));
    };

    const getClients = async () => {
        const clients = await api.clients.getAll();
        dispatch(actions.clients.set(clients));
    };

    const onFocus = (e: any) => {
        e.target.removeAttribute("readonly");
    };

    const handleChange = (e: any) => {
        setEmail(e.target.value);
        onKeyUp(e);
    };

    const onKeyUp = (e: any) => {
        console.log(e.target.value);

        if (e.target.value !== "") {
            if (e.taget.key === "Enter") {
                doLogin2();
            }
        } else {
            console.log("Got YA");
        }
    };

    useEffect(() => {
        localStorage.removeItem("AccessToken");
        dispatch(actions.user.set(null));
    }, []);

    return (
        <div className="login container">
            <div>
                <img src="/img/logo-full.svg" alt="amaSocial Logo" />
            </div>
            <div>
                <h2>LOGIN</h2>
                <input type="email" placeholder="Email" readOnly onFocus={onFocus} onKeyUp={(e) => (e.key === "Enter" ? doLogin2() : null)} onChange={(e: any) => setEmail(e.target.value)} value={email} />
                <input type="password" placeholder="Password" onChange={(e: any) => setPassword(e.target.value)} readOnly onFocus={onFocus} onKeyUp={(e) => (e.key === "Enter" ? doLogin2() : null)} />
                <button onClick={doLogin2} disabled={!email.length || !password.length}>
                    {!loading ? "LOGIN" : <i className="fal fa-spinner fa-spin"></i>}
                </button>
                <Link to="/forgot-password">FORGOT PASSWORD</Link>
            </div>
        </div>
    );
}

export default Login;
